import { Surface } from '../_components';
import { BASKET_SIZE } from '@/lib/alpha-basket';

export function InvestmentSystem() {
  return (
    <>
      <h2 className="text-[var(--gold)] text-[18px] font-semibold mb-3 mt-8">
        A complete investment system
      </h2>
      <p className="text-[13px] text-[#cbd5e1] leading-relaxed max-w-4xl mb-4">
        Most quantitative tools do one thing: a screen, a backtest, a risk report.
        The Visualizer does all of them, in one application, against one source of
        truth. A portfolio manager moves through six surfaces in a single workflow
        (research, scoring, portfolio review, position management, operational
        health, and external presentation) with every number on every screen
        reconciling end to end. The same composite that ranks a stock in the
        morning research is the same composite that drives the basket rebalance,
        the same composite shown to a client on the website, and the same
        composite the manager checks before sizing a new position.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <Surface tag="Active book" title="Portfolio">
          Live tracking of every holding with weighted return today, month to date,
          and year to date, alongside the same window for the SPY benchmark and the
          resulting excess. Side by side: sector exposure, concentration, covariance
          based volatility, beta, expected forward return, and a three layer fee
          analysis from gross fully invested down to net of management and
          performance fees. Click any name to see its contribution to risk and to
          return.
        </Surface>
        <Surface tag="Live model basket" title="Alpha Zone">
          The current top {BASKET_SIZE} names by composite, conviction weighted, with a
          live since-inception versus SPY card, a rebalance log that captures every
          entry and exit with the locked in return for the leg, and a 3D scatter
          that lets the manager scrub through a hundred and thirty seven months of
          history to see how today&rsquo;s basket would have looked at any prior
          point in the cycle.
        </Surface>
        <Surface tag="Daily research note" title="Research Desk">
          A daily idea note published only when a name clears strict incremental
          Sharpe, expected return, and correlation gates. A deterministic state
          machine confirms the rating before the supporting language is written;
          the prose is constrained to numbers the desk has already computed, so it
          can never fabricate a fact. Quiet days are the right answer when nothing
          clears the bar.
        </Surface>
        <Surface tag="Position management" title="Hedge Lab">
          For any holding the manager opens the Hedge Lab and sees six structured
          option strategies (trim, covered call, collar, cash secured put, stock
          replacement, hold) priced live from Bloomberg option chains. Each
          candidate carries a transparent fit score, a payoff diagram showing
          where the structure protects you and where it caps you, and a tax aware
          net of cost view.
        </Surface>
        <Surface tag="Operational health" title="Pipeline">
          A rolling five day status grid for every external pull and key compute
          step, with one click recovery for any failed cell. Cross file integrity
          checks verify scores, the basket, and the price cache are mutually
          consistent on every refresh. A site wide banner appears immediately if
          any check fails.
        </Surface>
        <Surface tag="External" title="Presentation and Website">
          A live sixteen slide investor deck and the public Triumph website both
          read directly from the same data files the model produces. When the
          basket changes in the morning, the deck and the site reflect it before
          lunch. There is no parallel set of marketing numbers; what a client
          sees is what the model just decided.
        </Surface>
      </div>
    </>
  );
}
